export default "__VITE_ASSET__tPfcLX0V__"